export const featureDataConcreteRestoration = {
    mainTitle: 'Why Choose HRD for Concrete Restoration?',
    items: [
        {
            number: '01',
            heading: 'Experienced Concrete Specialists – Over 20 years of expertise in commercial and high-rise concrete restoration.'
        },
        {
            number: '02',
            heading: 'Advanced Repair Techniques – Using cutting-edge materials and proven restoration methods.'
        },
        {
            number: '03',
            heading: 'Minimal Disruption – Strategically planned repairs to limit downtime and tenant impact.'
        },
        {
            number: '04',
            heading: 'Durability & Longevity – Extending the lifespan of your building with high-quality, lasting solutions.'
        },
        {
            number: '05',
            heading: 'Safety & Compliance – Adhering to WorkSafeBC and local building codes for safe and effective repairs.'
        }
    ],
    title: "Restore & Reinforce Your Concrete Structures",
    subtitle:
        'From commercial buildings and high-rises to parking structures and industrial facilities, HRD provides expert concrete restoration to keep your property safe, strong, and built to last.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/8concreteRestoration/featuregridSection/fondo.png'
};
